// import ExcelJS from 'exceljs';
import Product_Zaiko from '../classes/Product_Zaiko.js';
import ZaikoData from '../classes/ZaikoData.js';
import ZaikoDistributor from '../classes/ZaikoDistributor.js';

export function ImportZaikouData(sheet)
{
    let container = document.createElement('div');
    document.body.append(container);

    /* eslint-disable */
    const lastCol = sheet.lastColumn.number;
    const lastRow = sheet.lastRow.number;

    console.log('last row ' + sheet.lastRow, sheet.lastRow);

    const products = [];
    
    for(let i = 5; i < lastRow; i++)
    {
        const r = sheet.getRow(i);
        if (r.getCell(1).value === null)
        {
            // No product found, we are done
            break;
        }

        const prod = new Product_Zaiko(r);
        prod.SalesData = GetProductSalesData(sheet, r, lastCol);

        if (prod.JAN === null)
        {
            prod.JAN = 'no_jancode';
        }

        if (prod.StyleNumber === '411-200395F')
        {
            console.log('(Zaiko) Row ' + (i) + ' product data', prod);
        }

        products.push(prod);
    }

    return products;
}

// Returns an array of ZaikoData
function GetProductSalesData(sheet, row, lastCol)
{
    // ZaikoData[]
    const zaikoData = [];

    // console.log('(GetProductSalesData) last column: ', NumberToColumn(lastCol));

    // We need it here so it doesn't get reset
    // after every column
    let currentZaikoDistributor = null;

    let debugData = false;
    if (row.getCell(5).value === '411-200322G')
    {
        debugData = true;
        console.log('Check product 411-200322G until column', lastCol);
    }

    // Start from N
    for(let i = 14; i < lastCol; i++)
    {
        const c = row.getCell(i);

        if (c.value !== null)
        {
            // Get year
            let val = sheet.getCell(`${NumberToColumn(i)}1`)
            const year = parseInt(val);
            
            // Get month
            val = sheet.getCell(`${NumberToColumn(i)}3`);
            // Get index of 月
            let monthValue = val.toString().indexOf('月');
            if (monthValue === -1)
            {
                monthValue = val.toString().indexOf('/');
            }
            
            if (monthValue === -1)
            {
                //console.log('could not extract month at row ' + row.number, `${NumberToColumn(i)}3`);
                continue;
            }

            monthValue = parseInt(val.toString().substring(0, monthValue));

            if (isNaN(monthValue ) === true)
            {
                console.log('coult not get month number from ', monthValue);
                continue;
            }
            else
            {
                // console.log(`Currently checking ${monthValue}/${year}`);
            }

            let currentZaikoData = null;

            // Get ZaikoData first, based on Year and Month
            for (let j = 0; j < zaikoData.length; j++)
            {
                const zd = zaikoData[j];
                if (zd.Year === year &&
                    zd.Month === monthValue)
                {
                    currentZaikoData = zd;
                    break;
                }
            }

            if (currentZaikoData === null)
            {
                currentZaikoData = new ZaikoData(year, monthValue);
                zaikoData.push(currentZaikoData);
                if (debugData===true)
                {
                    console.log('add new zaiko data obj', currentZaikoData);
                }
            }

            
            if (debugData===true)
            {
                console.log(`${year}/${monthValue}月 Column${NumberToColumn(i)}`);
            }

            // Get data type
            const dataTypeCell = sheet.getCell(`${NumberToColumn(i)}3`);
            if (dataTypeCell.value === null)
            {
                // console.log('data type cell is empty', `${NumberToColumn(i)}3`);
                continue;
            }
            let dataType = null;
            let indexOfMonth = dataTypeCell.value.toString().indexOf('月');
            if (indexOfMonth === -1)
            {
                indexOfMonth = dataTypeCell.value.toString().indexOf('/');
            }

            if (indexOfMonth !== -1)
            {
                dataType = dataTypeCell.value.toString().substring(indexOfMonth + 1, dataTypeCell.value.length);
                // console.log('extracted data type from ' + dataTypeCell.value, dataType);
            }

            // If we don't have total orders yet, there's
            // 99% just a 0 remaining from drag and drop
            // actions in Excel
            // if (dataType !== '仕入')
            // {
            //     if (currentZaikoData.TotalOrders === null)
            //     {
            //         // console.log(`Skip ${monthValue}/${year} because of remaining copy-paste 0`);
            //         continue;
            //     }
            // }

            // Get hanbaisaki
            const newHanbaisakiValue = sheet.getCell(`${NumberToColumn(i)}2`).value;
            // console.log('newHanbaisakiValue in column ' + NumberToColumn(i) + '2', newHanbaisakiValue);
            if (newHanbaisakiValue !== null &&
                newHanbaisakiValue !== undefined &&
                newHanbaisakiValue.toString().trim() !== '' &&
                newHanbaisakiValue !== '見本処理')
            {
                currentZaikoDistributor = new ZaikoDistributor(newHanbaisakiValue);
                currentZaikoData.SalesInformation.push(currentZaikoDistributor);
                if(debugData===true)
                {
                    console.log('adding new zaiko distributor obj', currentZaikoDistributor);
                }
            }

            // 2025/01/15
            // HAVE TO FIND OUT WHY THE INFORMATION OF OTHER MONTHS IS NOT ADDED

            // Get the cell value
            let cellValue = parseInt(c.value);
            if (isNaN(cellValue) === true)
            {
                // console.log('Found NaN in Row ' + row.number + "-" + NumberToColumn(i) , c.value);
                // console.log('try formula');
                if (c.formula)
                {
                    // console.log('formula ' + c.formula, c.result);
                    cellValue = c.result;

                    if (isNaN(cellValue) === true)
                    {
                        // console.log('still nothin');
                        
                        if (debugData===true)
                        {
                            console.log('skipping cell, content is NaN');
                        }
                        continue;
                    }
                }
                else
                {
                    if (debugData===true)
                    {
                        console.log('skipping cell, content is not a formula');
                    }
                    continue;
                }
            }

            switch(dataType)
            {
                case '仕入':
                    // We should not rely on this but calculate
                    // the total in the end our self because of
                    // human error (2025/01/15)
                    // It's a copy paste 0 or something,
                    // but since we don't have any total
                    // here, we can skip the month entirely
                    // if (cellValue === 0)
                    // {
                    //     // Skip next column as well
                    //     i += 2;
                    //     continue;
                    // }

                    // 2025/01/15
                    // We have to recalculate the two values
                    // at the end of the month
                    currentZaikoData.TotalOrders = cellValue;

                    // and set the total production cost
                    let costCell = sheet.getCell(`${NumberToColumn(i + 1)}${row.number}`);
                    currentZaikoData.TotalProductionCost = costCell.result;
                    
                    // console.log(`Updated Zaiko data for ${monthValue}/${year}`, currentZaikoData);

                    // increase i by one to skip the following column
                    // because there's nothing written in the cell
                    // containing the total production cost
                    i++;
                    break;

                case '出荷':
                    if (currentZaikoDistributor === null)
                    {
                        if (debugData===true)
                        {
                            console.log('skipping 出荷 because of currentZaikoDistributor NULL');
                        }
                        // There may be a copy-paste 0 again,
                        // otherwise we would have created a
                        // distributor instance in the previous
                        // orders column
                        // console.log(`No ZaikoDistributor instance for ${year}/${monthValue} - ${newHanbaisakiValue} at column ${NumberToColumn(i)}${row.number}`);
                        continue;
                    }
                    if (debugData===true)
                    {
                        console.log('Set orders ', cellValue);
                    }
                    currentZaikoDistributor.Orders = cellValue;
                    if (debugData===true)
                    {
                        console.log('Set orders in distributor obj',currentZaikoDistributor);
                    }
                    break;

                case '売上':
                    if (currentZaikoDistributor === null)
                    {
                        if (debugData===true)
                        {
                            console.log('skipping 売上 because of currentZaikoDistributor NULL');
                        }
                        // There may be a copy-paste 0 again,
                        // otherwise we would have created a
                        // distributor instance in the previous
                        // orders column
                        // console.log(`No ZaikoDistributor instance for ${year}/${monthValue} - ${newHanbaisakiValue} at column ${NumberToColumn(i)}${row.number}`);
                        continue;
                    }
                    currentZaikoDistributor.Sales = cellValue;
                    break;

                case '利益':
                    if (currentZaikoDistributor === null)
                    {
                        if (debugData===true)
                        {
                            console.log('skipping 利益 because of currentZaikoDistributor NULL');
                        }
                        // There may be a copy-paste 0 again,
                        // otherwise we would have created a
                        // distributor instance in the previous
                        // orders column
                        // console.log(`No ZaikoDistributor instance for ${year}/${monthValue} - ${newHanbaisakiValue} at column ${NumberToColumn(i)}${row.number}`);
                        continue;
                    }
                    currentZaikoDistributor.Profit = cellValue;
                    break;

                case '末pcs':
                    currentZaikoData.InventoryQuantity = cellValue;
                    break;

                case '処理数':
                    // if (currentZaikoData.Year === 2025 && currentZaikoData.Month === 1)
                    //     console.log(`Sample number in cell ${NumberToColumn(i)}${row.number}`, cellValue);
                    currentZaikoData.NumberOfSamples = cellValue;
                    break;
            }
            
        }
    }

    for (let i = 0; i < zaikoData.length; i++)
    {
        zaikoData[i].TotalOrders = 0;
        const salesData = zaikoData[i].SalesInformation;

        for (let j = 0; j < salesData.length; j++)
        {
            zaikoData[i].TotalOrders += salesData[j].Orders;
            // if(debugData===true)
            // {
            //     console.log('add orders ' + salesData[j].Orders + ' to total orders', zaikoData[i]);
            // }
        }

        if (typeof zaikoData[i].InventoryQuantity === typeof 0)
        {
            zaikoData[i].TotalOrders += zaikoData[i].InventoryQuantity;
            // if(debugData===true)
            // {
            //     console.log('add InventoryQuantity ' + zaikoData[i].InventoryQuantity + ' to total orders', zaikoData[i]);
            // }
        }
        else
        {
            if(debugData===true)
            {
                console.log('typeof InventoryQuantity ', typeof zaikoData[i].InventoryQuantity);
            }
        }

        if (typeof zaikoData[i].NumberOfSamples === typeof 0)
        {
            zaikoData[i].TotalOrders += zaikoData[i].NumberOfSamples;
            // if(debugData===true)
            // {
            //     console.log('add NumberOfSamples ' + zaikoData[i].NumberOfSamples + ' to total orders', zaikoData[i]);
            // }
        }
        else
        {
            if(debugData===true && zaikoData[i].NumberOfSamples !== null)
            {
                console.log('typeof NumberOfSamples ', typeof zaikoData[i].NumberOfSamples);
                if (typeof zaikoData[i].NumberOfSamples == 'object')
                {
                    console.log('samples object', zaikoData[i].NumberOfSamples);
                }
            }
        }
    }

    // console.log('all zaikoData', zaikoData);

    // Remove empty sales information
    for (let i = zaikoData.length - 1; i >= 0; i--)
    {
        if (zaikoData[i].TotalOrders === null)
        {
            zaikoData.splice(i, 1);
        }
    }

    return zaikoData;
}

export function ColumnToNumber(columnString)
{
    columnString = columnString.toUpperCase(); // Ensure uppercase for consistency
  
    let number = 0;
    for (let i = 0; i < columnString.length; i++) {
      const charCode = columnString.charCodeAt(i);
      const offset = charCode - 65; // Offset from 'A' (65)
  
      // Consider single-digit columns (A-Z) and multi-digit columns (AA, AB, etc.)
      number = (number * 26) + (offset + 1);
    }
  
    return number;
}

export function NumberToColumn(number)
{
    var n = (number - 1) % 26;
    var c = String.fromCharCode(65 + n);
    var n2 = Math.floor((number - 1) / 26);
    if (n2 > 0) {
        return NumberToColumn(n2) + c;
    } else {
        return c;
    }
}